<template>
  <v-card flat class="pa-4" :style="{ backgroundColor: cardBg }">
    <v-card-title class="text-h6">
      Configurare AD
    </v-card-title>
    <v-divider class="my-2"></v-divider>

    <DxDataGrid
      ref="dataGridRef"
      :data-source="adSettings"
      :show-borders="true"
      :column-auto-width="true"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :remote-operations="false"
      :editing="{ allowUpdating: true, allowAdding: true, allowDeleting: true, mode: 'popup' }"
      @row-inserting="onRowInserting"
      @row-updating="onRowUpdating"
      @row-removing="onRowRemoving"
    >
      <DxPaging :page-size="5" />
      <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5,10,20]" show-info />
      <DxColumn data-field="Hostname" />
      <DxColumn data-field="Port" />
      <DxColumn data-field="UserName" />
      <DxColumn data-field="PasswordCipher" />
      <DxColumn data-field="Domain" />
      <DxColumn data-field="SearchBase" />
      <DxColumn data-field="ContainerName" />
      <DxColumn data-field="DomainName" />
      <DxColumn data-field="DomainDistinguishedName" />
      <DxColumn data-field="SearchProperty" />
    </DxDataGrid>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import DxDataGrid, { DxColumn, DxPaging, DxPager } from "devextreme-vue/data-grid";
import ADServices from "@/services/AUTH/AD_Services";

export default defineComponent({
  name: "ADTab",
  components: { DxDataGrid, DxColumn, DxPaging, DxPager },
  setup() {
    const adSettings = ref<any[]>([]);
    const dataGridRef = ref<any>(null);
    const cardBg = "#f9f9f9";

    const loadSettings = () => {
      ADServices.getSettings()
        .then(res => {
          adSettings.value = res.data;
        })
        .catch(console.error);
    };

    const onRowInserting = async (e: any) => {
      try {
        await ADServices.createSetting(e.data);
        loadSettings();
      } catch (err) {
        console.error(err);
      }
    };

    const onRowUpdating = async (e: any) => {
      try {
        await ADServices.updateSetting(e.key.id, e.newData);
        loadSettings();
      } catch (err) {
        console.error(err);
        e.cancel = true;
      }
    };

    const onRowRemoving = async (e: any) => {
      try {
        await ADServices.deleteSetting(e.data.id);
        loadSettings();
      } catch (err) {
        console.error(err);
        e.cancel = true;
      }
    };

    onMounted(loadSettings);

    return { adSettings, dataGridRef, cardBg, onRowInserting, onRowUpdating, onRowRemoving };
  }
});
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}
</style>
